export default __webpack_public_path__ + "static/media/marauders-map-v4-gallery-02.7c95da5b.jpg";